<template>
  <div v-if="fetching" class="w-full flex items-center justify-center my-12">
    <base-icon class="icon-spin text-primary-light text-5xl" icon="spinner2" />
  </div>
</template>

<script>
import BaseIcon from './_base-icon.vue'

export default {
  components: {
    BaseIcon,
  },

  props: {
    fetching: Boolean,
  },
}
</script>
